<template>
  <aside class="branding-page">
    <div>
      <DocumentPageTitle
        :show-word-count="false"
        title="Branding Settings"
      />
      <p class="light-chrome-banner">
        Select a brand color for your <span class="font-semibold">PDF headings</span>. You can use the color picker or enter a hex code below.
      </p>

      <ColourPicker
        id="branding"
        v-model.trim="planStore.content.headingColour"
        v-focus
        label="Heading Colour"
        required
      />
    </div>
  </aside>
</template>

<script setup>
import { usePlanStore } from '@/store';
import { ColourPicker } from '@/components/form-inputs';
import { DocumentPageTitle } from '@/components/plan-document/components';

const planStore = usePlanStore();
</script>
